import { Box } from "@mui/system";

import { Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { heightWithToolbar } from "../global";
import { ContractorsDatagrid } from "../hooks/contractorsDatagrid/contractorsDatagrid";
import { usePro } from "../hooks/usePro/usePro";
import { setFormOpen } from "../reducers/rhapsody";
import { proEnabled } from "../constants";

export default function Contractors() {
  const param = useParams();
  const pro = usePro();
  const dispatch = useDispatch();
  if (param.contractorID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Organizations</title>
        </Helmet>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography level="h6">Organizations</Typography>
          {proEnabled ? (
            <Button
              onClick={() =>
                dispatch(setFormOpen({ isOpen: true, formID: "contractor" }))
              }
              size="sm"
              color="info"
            >
              + New Organization
            </Button>
          ) : (
            []
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
          }}
        >
          <ContractorsDatagrid />
        </Box>
      </Box>
    </>
  );
}
